import i18n from "../i18n/i18n.js";
import router from "../router";
import axios from "axios";
import { Message } from "element-ui";

import { handleNavColor } from "@/plugins/handleNavColor";
const CORS_ERROR = i18n.t("LAYOUT.CORS");

const token = localStorage.getItem("AC_token");

if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}
axios.defaults.baseURL =
  process.env.NODE_ENV === "development" ? "/api" : process.env.VUE_APP_BASEURL;

// 統一異常處理
axios.interceptors.response.use(
  (response) => {
    handleNavColor(true);
    return response;
  },
  (err) => {
    if (err && err.response) {
      console.log("axios interceptors response:");
      switch (err.response.status) {
        case 401:
          // Message({
          //   message: "授權失敗，請重新登入。(401）",
          //   center: true,
          //   iconClass: "el-icon-circle-close",
          //   customClass: "msg msg-error",
          // });
          router.push("/login");
          break;
        case 403:
          console.log("403 error");
          Message({
            message: "403 error",
            center: true,
            iconClass: "el-icon-circle-close",
            customClass: "msg msg-error",
          });
          break;
        case 404:
          console.log("404 error");
          break;
        case 500:
          console.log("500 error");
          break;
        case 503:
          console.log("503 error");
          break;
        default:
          // console.log(err.response);
          console.log(`Other error ${err.response.status}`);
      }
    } else {
      if (process.env.NODE_ENV === "development") {
        Message({
          message: CORS_ERROR,
          center: true,
          iconClass: "el-icon-circle-close",
          customClass: "msg msg-error",
        });
      }
      handleNavColor(false);
      console.log(CORS_ERROR);
    }
    return Promise.reject(err.response);
  }
);

const request = {
  get(url, params) {
    return axios.get(url, params);
  },
  post(url, data = {}, config) {
    return axios.post(url, data, config);
  },
  delete(url, data = {}) {
    return axios.delete(url, data);
  },
  put(url, data = {}) {
    return axios.put(url, data);
  },
};

export default request;
